import fetch from 'isomorphic-fetch';

import { showConfirmationModal } from 'actions/confirmationModal';
import { showErrorBar } from 'actions/errorBar';
import { ERROR } from 'constants/error-severities';
import { HEADER_CONTENT_TYPE } from 'constants/http';
import { JSON as JSON_MIME } from 'constants/mimes';
import { FolderVisibility } from 'constants/visibility';
import { getGraphQLClient } from 'utilities/graphql';
import * as sentry from 'utilities/sentry';

import DuplicateFolder from './DuplicateFolder.graphql';

import UpdateFolderVisibility from 'components/folder-card/folder-visibility/UpdateFolderVisibility.graphql';

export function duplicateFolderCreator(id, newName = null) {
  return dispatch => {
    return fetch('/v1/folders/duplicate', {
      credentials: 'include',
      headers: { [HEADER_CONTENT_TYPE]: JSON_MIME },
      method: 'POST',
      body: JSON.stringify({ id, newName }),
    })
      .then(resp => {
        if (resp.status >= 400) {
          throw new Error(
            `Oops! Error duplicating folder - HTTP response: ${resp.status}`
          );
        }

        return resp.json();
      })
      .then(newVideoJSON => {
        dispatch(
          showConfirmationModal(`${newVideoJSON.name} successfully created 🤓`)
        );
      })
      .catch(err => {
        sentry.logException(err, 'error in duplicate folder creator');
        dispatch(showErrorBar(ERROR, err.toString()));
      });
  };
}

export function duplicateFolderGraphQL(folderId, newName) {
  return dispatch => {
    getGraphQLClient()
      .mutate({
        mutation: DuplicateFolder,
        variables: { folderId, newName },
        refetchQueries: ['GetPublishedFolders'],
      })
      .then(({ data }) => {
        if (data.duplicateFolder.__typename === 'GenericError') {
          dispatch(showErrorBar(ERROR, data.duplicateFolder.message));
        } else {
          dispatch(
            showConfirmationModal(
              `${data.duplicateFolder.newFolder.name} successfully created`
            )
          );
        }
      })
      .catch(() => {
        dispatch(showErrorBar(ERROR, 'Oops! Unable to duplicate folder'));
      });
  };
}

export function publishFoldersGraphQL(
  folderIds,
  isPublished,
  shouldUpdateVideos = false
) {
  return async (dispatch, getState) => {
    const workspaceId = getState().workspace.workspaces.find(
      ws => ws.isSelected
    )?.id;

    await Promise.all(
      folderIds.map(folderId => {
        getGraphQLClient()
          .mutate({
            mutation: UpdateFolderVisibility,
            variables: {
              folderId,
              workspaceId,
              visibility: isPublished
                ? FolderVisibility.WORKSPACE
                : FolderVisibility.OWNER,
              shouldUpdateVideos,
            },
          })
          .then(({ data }) => {
            if (data.updateFolderVisibility.__typename === 'GenericError') {
              dispatch(
                showErrorBar(ERROR, data.updateFolderVisibility.message)
              );
            }
          });
      })
    );
  };
}
